import {
  Driver,
  DriverVehicleInfo,
  Company,
  Product,
  ErrorResponse,
} from "./queriesApi.generated";

const EMPTY_RECORD: Record<string, unknown> = {};

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  Object.prototype.toString.call(value) ===
  Object.prototype.toString.call(EMPTY_RECORD);

export const isDriver = (value: unknown): value is Driver =>
  isRecord(value) &&
  "id" in value &&
  "first_name" in value &&
  "last_name" in value &&
  typeof value.id === "number";

export const isDriverVehicleInfo = (
  value: unknown,
): value is DriverVehicleInfo =>
  isRecord(value) &&
  "id" in value &&
  "number" in value &&
  "default_truck_for_driver" in value &&
  "default_trailer_for_driver" &&
  typeof value.id === "number";

export const isCompany = (value: unknown): value is Company =>
  isRecord(value) &&
  "id" in value &&
  "name" in value &&
  "registry_code" in value &&
  "is_supplier" &&
  "is_transporter" &&
  "is_buyer" &&
  typeof value.id === "number";

export const isProduct = (value: unknown): value is Product =>
  isRecord(value) &&
  "id" in value &&
  "name" in value &&
  !("registry_code" in value) &&
  !("first_name" in value) &&
  !("last_name" in value) &&
  typeof value.id === "number";

export const isStatus = (
  value: unknown,
): value is
  | "DRAFT"
  | "NEW"
  | "APPROACHING_ORIGIN"
  | "APPROACHING_DESTINATION"
  | "IN_DESTINATION"
  | "CONFIRMED"
  | "CANCELLED" =>
  typeof value === "string" &&
  [
    "DRAFT",
    "NEW",
    "APPROACHING_ORIGIN",
    "APPROACHING_DESTINATION",
    "IN_DESTINATION",
    "CONFIRMED",
    "CANCELLED",
  ].includes(value);

export const isEntryStatus = (
  value: unknown,
): value is "default" | "pending" | "completed" | "deleted" =>
  typeof value === "string" &&
  ["default", "pending", "completed", "deleted"].includes(value);

export const isErrorResponse = (value: unknown): value is ErrorResponse => {
  return (
    isRecord(value) &&
    "error_code" in value &&
    "detail" in value &&
    typeof value.error_code === "string" &&
    (typeof value.detail === "string" || Array.isArray(value.detail))
  );
};
